export class MedicalListLang {

    variables  = null;

    constructor(lang,new_lang) {

        this.variables = {
            name: lang.course[1],
            sno: lang.course[109],
            subject: lang.course[54],
            text: lang.course[153],
            date: lang.course[148],
            notification: lang.course[128],
            action: lang.course[28],
            selectColumns: lang.general[9],
            selectAll: lang.general[10],
            activeColumns: lang.general[11],
            close: lang.general[17],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            print: lang.general[16],
            humanResources: lang.general[42],
            view: lang.general[3],
            erase: lang.general[4],
            select_type: lang.course[155],
            import: lang.course[65],
            todownloadtocsv: lang.course[51],
            save: lang.general[0],
            examination: lang.course[231],
            description: lang.course[147],
            noofEmployees: lang.course[274],
            employees: lang.course[107],
            firstVisit: lang.course[151],
            validity: lang.course[143],
            nextVisit: lang.course[152],
            daysleft: lang.course[57],
            attachments: lang.course[150],
            modify: lang.general[2],
            importMedication: lang.course[222],
            clickhere: lang.course[50],
            doctor: lang.course[227],
            exam_date:new_lang[226],
            employee:new_lang[279],
            outcome:new_lang[29],
            notes:lang.course[149],
            cost:new_lang[15],
            distribustion_status:new_lang[267],
            date_of_sent:new_lang[268],
            reference_email:new_lang[228],
            general_data:new_lang[125],
            mail: lang.general[5],
            sender:lang.course[362],
            send_to:lang.course[363],
            intervention_exam_date:lang.course[277],
            intervention_days_notify:lang.course[242],
            medical_examination: lang.general[45],
            create_medical_exam:lang.course[340],
            edit_medical_exam:lang.course[341],
            occurrence:lang.course[239],
            new_intervention:lang.course[237],
            search: lang.general[33],
        }

    }

    lang() {
        return this.variables;
    }

}


export class MedicalGeneralLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            name: lang.course[1],
            sno: lang.course[109],
            subject: lang.course[54],
            text: lang.course[153],
            date: lang.course[148],
            notification: lang.course[128],
            action: lang.course[28],
            selectColumns: lang.general[9],
            selectAll: lang.general[10],
            activeColumns: lang.general[11],
            close: lang.general[17],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            print: lang.general[16],
            humanResources: lang.general[42],
            view: lang.general[3],
            erase: lang.general[4],
            requiredField:lang.general[26],
            addNotification:lang.course[266],
            type:lang.course[135],
            description:lang.course[147],
            notes:lang.course[149],
            attachments:lang.course[150],
            save:lang.course[80],
            select_type:lang.course[155],
            communication:lang.course[186],
            consultation:lang.course[187],
            other:lang.course[188],
            newExamination:lang.course[224],
            examination:lang.course[231],
            doctor: lang.course[227],
            employees: lang.course[107],
            referenceEmail: lang.course[228],
            open: lang.course[73],
            selectEmployee: lang.course[230],
            validEmail: lang.general[73],
            general_data: lang.course[125],
            first_visit:lang.course[151],
            repeating_period:lang.course[195],
            set_repetitions:lang.course[200],
            end_date:lang.course[10],
            date_notify:lang.course[241],
            notification_time:lang.course[197],
            sender:lang.course[264],
            send_to:lang.course[265],
            intervention_exam_date:lang.course[277],
            intervention_days_notify:lang.course[242],
            skip:lang.course[245],
            change:lang.course[48],
            do_not_affect:lang.course[246],
            outcome:lang.course[29],
            cost:lang.course[15],            
            modify: lang.general[2],
            create_medical_exam:lang.course[340],
            edit_medical_exam:lang.course[341],
            choose_file: lang.general[108],
            date_of_execution:lang.course[342],
            new_visit:lang.course[270],
            search: lang.general[33],
        }

    }

    lang() {
        return this.variables;
    }

}
